export { default as MenuVerticalIcon } from '~icons/ion/ellipsis-vertical';
